/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".sidebar-basic-example .ExampleCard .ExampleCard-example{height:500px;padding-bottom:0}.sidebar-collapsed-example .ExampleCard .ExampleCard-example{height:500px;padding-bottom:0}\n"}]);